<template>
    <v-container fluid>
        <h2 class="d-flex justify-center titulo">
            Seja bem-vindo ao validador!
        </h2>
        <span class="d-flex justify-center texto-principal">
            <span>
                Utilize o campo abaixo para verificar o documento <br> e validar sua autenticidade e assinaturas.
            </span>
        </span>
        <v-card class="mx-auto my-12 card-input" max-width="500" height="150">
            <strong class="d-flex justify-center">
                Informe o código do documento
            </strong>
            <v-layout justify-center>
                <v-flex xs5 sm5 md5>
                    <v-text-field v-model="codigoDocumento" v-mask="customTokens" v-validate="regrasValidacaoCodigo()"
                                  placeholder="ex: XY1Z-A2BC-3BRL-LFS4" name="código" class="centered-input"
                                  :error-messages="errors.collect('código').length > 0 ? ['Codigo inválido'] : []" />
                </v-flex>
            </v-layout>
            <v-layout justify-center>
            <span class="text-center" style="padding-top: 2px">
                <az-call-to-action @click="validar" css-class="text-uppercase action-primary botao-default filled">
                    Validar
                </az-call-to-action>
            </span>
            </v-layout>
        </v-card>
        <br>
        <v-card class="mx-auto card-input" max-width="500" height="150">
            <v-layout row>
                <v-flex xs9>
                    <div style="padding-left: 10px">
                        <strong class="d-flex justify-start" style="padding-bottom: 5px">
                            Não encontrou o código?
                        </strong>
                        <span>
                            O <strong>"código de validação"</strong> do seu documento encontra-se no topo
                            da última página do documento, e é composto de 16 caracteres separados em grupos de 4.
                        </span>
                    </div>
                </v-flex>
                <v-flex xs2 class="mini-documento-exemplo">
                    <v-card width="90" height="120" hover color="#f2f2f2">
                        <span class="d-flex justify-center" style="font-size: 12px">
                            Documento
                        </span>

                        <div class="container-codigo-exemplo">
                            <div>Código:</div>
                            <div class="codigo-exemplo">
                                XY1Z-A2BC-3BR...
                            </div>
                        </div>

                        <div style="left: 4px; padding: 1px">
                            <div style="font-size: 10px">Assinaturas:</div>
                        </div>
                        <hr>
                        <hr>
                        <hr>
                        <hr>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-card>

    </v-container>
</template>
<script>
export default {
    name: 'BuscaPorCodigo',
    inject: ['$validator'],
    data() {
        return {
            codigoDocumento: null,
            customTokens: {
                mask: 'FFFF-FFFF-FFFF-FFFF',
                tokens: {
                    'F': {
                        pattern: /[0-9a-zA-Z]/,
                        transform: v => v.toLocaleUpperCase()
                    }
                }
            }
        }
    },
    methods:{
        async validar(){
            await this.validarCampoObrigatorio()
            this.$emit('validarDocumento', this.codigoDocumento)
        },
        regrasValidacaoCodigo(){
            return 'required|length:19'
        },
        async validarCampoObrigatorio() {
            const estaValido = await this.$validator._base.validateAll()
            if (!estaValido || !this.codigoDocumento) {
                throw new Error('O código deve ser preenchido corretamente.')
            }
        }
    }
}
</script>
<style>
    .titulo{
        padding-top: 20px;
    }

    .texto-principal{
        padding-top: 15px;
        padding-bottom: 20px;
        text-align: center;
    }

    .centered-input input {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #b5b5b5;
        text-align: center
    }

    .card-input{
        padding-top: 15px;
    }

    .mini-documento-exemplo{
        padding-left: 15px
    }

    .container-codigo-exemplo{
        left: 4px;
        padding: 1px;
        font-size: 10px
    }

    .codigo-exemplo{
        border: 1px solid red;
        border-radius: 4px;
        padding: 1px
    }

    hr {
        display: block;
        height: 1px;
        border: 0;
        border-top: 1px solid #ccc;
        margin: 4px;
        padding: 0;
    }

</style>

<style scoped>
    .centered-input >>> .v-messages__message{
        text-align: center;
    }

    .filled{
        background-color: var(--v-primary-base) !important;
        color: white !important;
        border-radius: 5px;
    }

</style>
